import { render, staticRenderFns } from "./NhomTPDanhGiaList.vue?vue&type=template&id=70eb0060&"
import script from "./NhomTPDanhGiaList.vue?vue&type=script&lang=js&"
export * from "./NhomTPDanhGiaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports